export default __webpack_public_path__ + "static/nc-14467e33f30091e082cb624d52c3321a.svg";